import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  quotas: [],
  globalLimits: [],
  logs: [],
};

export default {
  namespaced: true,
  name: "redisQuotas",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_REDIS_QUOTAS](state, payload = []) {
      state.quotas = payload;
    },
    [actions.GET_REDIS_GLOBAL_LIMITS](state, payload = []) {
      state.globalLimits = payload;
    },
    [actions.GET_REDIS_GLOBAL_LIMIT_LOGS](state, payload = []) {
      state.logs = payload;
    },
  },
  actions: {
    async fetchRedisQuotas({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.redisQuotas.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_REDIS_QUOTAS, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_REDIS_QUOTAS, []);
          reject(error);
        }
      });
    },
    async unblockNumber(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.redisQuotas.unblock,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async fetchGlobalLimits({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.redisQuotas.globalLimits,
            "GET",
            null,
            payload
          );
          commit(actions.GET_REDIS_GLOBAL_LIMITS, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_REDIS_GLOBAL_LIMITS, []);
          reject(error);
        }
      });
    },
    async updateGlobalLimit(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.redisQuotas.globalLimits,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async fetchGlobalLimitLogs({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.redisQuotas.globalLimitLogs,
            "GET",
            null,
            payload
          );
          commit(actions.GET_REDIS_GLOBAL_LIMIT_LOGS, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_REDIS_GLOBAL_LIMIT_LOGS, []);
          reject(error);
        }
      });
    },
  },
};
